export default {
  computed: {
    stateRegions: {
      get () {
        return this.filters.regions
      },

      set (value) {
        this.setFilterMutation({ filter: 'regions', value })
      }
    },

    stateVisibility: {
      get () {
        return this.filters.visibility
      },

      set (value) {
        this.setFilterMutation({ filter: 'visibility', value })
      }
    },

    stateKeywords: {
      get () {
        return this.filters.keywords
      },

      set (value) {
        this.setFilterMutation({ filter: 'keywords', value })
      }
    }
  }
}
